import { format, formatDistanceToNow, getTime } from 'date-fns';

export function fDate(date: string, newFormat: string = 'dd MMM yyyy') {
  return date ? format(new Date(date), newFormat) : '';
}

export function fDateTime(date: string, newFormat: string = 'dd MMM yyyy p') {
  return date ? format(new Date(date), newFormat) : '';
}

export function fTimestamp(date: string) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: string) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}
